export var pdfType = 'application/pdf';
export var pngType = 'image/png';
export default {
    maxUploadFileSize: 5242880,
    maxFileSize: '5MB',
    maxFiles: 10,
    fileType: {
        Pdf: 'pdf',
        Image: 'image'
    },
    supportedFileTypes: ['image/jpg', 'image/jpeg', pngType, pdfType]
};
//# sourceMappingURL=fileUploadConfig.js.map